import { CircularProgress } from '@mui/material'

function Spinner({ height = '200px' }: { height?: string | number }) {
  return (
    <div
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        height,
        display: 'flex',
      }}
    >
      <CircularProgress />
    </div>
  )
}

export default Spinner
